import * as types from './actionTypes';
import { getRequest, putRequest } from '../../lib/apiUtils';
import { getUserPermissions } from './UsersActions';

export function getUserProfileAndPermissions() {
    return async (dispatch, getState) => {
        await dispatch(getUserProfile());
        
        if(getState().userProfile.profile.success) 
            await dispatch(getUserPermissions(getState().userProfile.profile.data.userId, true));
    }
}

export function getUserProfile() {
    return async dispatch => {
        dispatch({ type: types.START_GET_USER_PROFILE });

        const response = await getRequest('/account/myprofile');

        dispatch({ type: types.GET_USER_PROFILE, response });
    }
}

export function updateAiSummaryPreference(showAiSummaries) {
    return async dispatch => {
        const response = await putRequest('/account/ai-summary-preference', { showAiSummaries });

        if (response.success) {
            dispatch({ type: types.UPDATE_USER_PROFILE, update: { showAiSummaries } });
        }

        return response;
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/UserProfileActions.js